import { render } from "./Home.vue?vue&type=template&id=c6c5f9b2"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=c6c5f9b2&lang=stylus"
script.render = render

export default script